import { render, staticRenderFns } from "./transportTimesStatistics.vue?vue&type=template&id=27f7620a&scoped=true"
import script from "./transportTimesStatistics.vue?vue&type=script&lang=js"
export * from "./transportTimesStatistics.vue?vue&type=script&lang=js"
import style0 from "./transportTimesStatistics.vue?vue&type=style&index=0&id=27f7620a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f7620a",
  null
  
)

export default component.exports